import { createAction, props } from "@ngrx/store";
export const propertiesSearch = createAction('[tab-properties] PropertiesSearch', props());
